import { SoundManager } from "@lib/titan2/dist/game/manager/SoundManager";
/**
 * SoundConstants.ts
 */
export class SoundConstants {
    static getBackground(matchedPatterns) {
        let properties;
        if (matchedPatterns >= 9) {
            properties = SoundManager.getInstance().getRegisteredSound("BACKGROUND_3");
        }
        else if (matchedPatterns >= 4) {
            properties = SoundManager.getInstance().getRegisteredSound("BACKGROUND_2");
        }
        else {
            properties = SoundManager.getInstance().getRegisteredSound("BACKGROUND_1");
        }
        return properties;
    }
    static getLevelUp(matchedPatterns) {
        let properties;
        if (matchedPatterns >= 4) {
            properties = SoundManager.getInstance().getRegisteredSound("LEVEL_UP_4");
        }
        else if (matchedPatterns === 3) {
            properties = SoundManager.getInstance().getRegisteredSound("LEVEL_UP_3");
        }
        else {
            properties = SoundManager.getInstance().getRegisteredSound("LEVEL_UP_1");
        }
        return properties;
    }
    static getDab(numberOfDabs) {
        let dabs = Math.max(1, Math.min(numberOfDabs, 5));
        return SoundManager.getInstance().getRegisteredSound(`DAB_SUCCESS_${dabs}`);
    }
}
//# sourceMappingURL=SoundConstants.js.map